import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbAuthModule,
  NbAuthSimpleToken,
  NbPasswordAuthStrategy,
} from "@nebular/auth";
import {
  NbDatepickerModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { CoreModule } from "./@core/core.module";
import { BearerInterceptor } from "./beared-interceptor";
import { HttpLoadingInterceptor } from "./http-request-interceptor";
import { environment } from "../environments/environment";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NbSpinnerModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: "email",
          baseEndpoint: environment.apiUrl,
          login: {
            method: "post",
            endpoint: "auth/login",
            redirect: {
              success: "/pages",
              failure: null,
            },
          },
          logout: {
            endpoint: "",
            redirect: {
              success: "/auth/login",
            },
          },
          token: {
            class: NbAuthSimpleToken,
            key: "access_token",
          },
        }),
      ],
      forms: {
        login: {
          redirectDelay: 0,
          password: {
            required: true,
            regexp: /^.{8,}$/,
          },
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: {
        handleError(error: any): void {
          // After a new deploy, old lazy-loaded chunk filenames no longer exist.
          // Auto-reload once so the browser picks up the latest build.
          if (error?.name === 'ChunkLoadError' || /Loading chunk .+ failed/i.test(error?.message ?? '')) {
            window.location.reload();
            return;
          }
          console.error(error);
        },
      },
    },
  ],
})
export class AppModule {}
